// extracted by mini-css-extract-plugin
module.exports = {"when":"style_when__3YH32"};